import { graphql } from "react-relay";

/////////
// GQL //
/////////

export const fragments = {
  flagsErrorable: graphql`
    fragment TutorialTeamSharedCalendar_flagsErrorable on FlagsErrorable {
      __typename
      ... on Flags {
        flags
      }
    }
  `,
};
